import React from 'react';

const traitIcons = {
  'Press': '🧬',
  'Hydro': '💧',
  'Aero': '🌬️',
  'Heat': '🔥',
};

const traitColors = {
  'Press': '#60A5FA',
  'Hydro': '#38BDF8',
  'Aero': '#A3E635',
  'Heat': '#F87171',
};

export default function BioticMadnessSiteInfoCard() {
  return (
    <div
      className="rounded-xl shadow-md p-5 mb-4"
      style={{
        background: 'linear-gradient(120deg, #FEF9C3 90%, #FDE68A 100%)',
        border: '1.5px solid #FDE68A',
        minWidth: 260,
        maxWidth: 320,
        color: '#444',
        fontFamily: 'inherit',
      }}
    >
      <div className="font-bold text-lg mb-2" style={{ color: '#b45309', letterSpacing: '0.01em' }}>Biotic Madness</div>
      <div className="text-xs font-semibold mb-1" style={{ color: '#a16207' }}>ATTRIBUTES</div>
      <ul className="mb-3 text-sm">
        <li><span className="font-medium">Resilience:</span> <span style={{ color: '#2563eb' }}>4 – 8</span></li>
        <li><span className="font-medium">Mobility:</span> <span style={{ color: '#2563eb' }}>3 – 7</span></li>
        <li><span className="font-medium">Metabolism:</span> <span style={{ color: '#2563eb' }}>2 – 6</span></li>
      </ul>
      <div className="text-xs font-semibold mb-1" style={{ color: '#a16207' }}>TRAITS</div>
      <div className="mb-1 text-sm">
        <span className="font-medium">Desired:</span>{' '}
        <span style={{ color: traitColors['Aero'], fontWeight: 600 }}>
          {traitIcons['Aero']} Aero
        </span>
      </div>
      <div className="mb-1 text-sm">
        <span className="font-medium">Undesired:</span>{' '}
        <span style={{ color: traitColors['Hydro'], fontWeight: 600 }}>
          {traitIcons['Hydro']} Hydro
        </span>
      </div>
      <div className="mb-1 text-sm">
        <span className="font-medium">All traits:</span>{' '}
        {['Press', 'Hydro', 'Aero', 'Heat'].map(trait => (
          <span key={trait} style={{ color: traitColors[trait], marginRight: 8, fontWeight: 600 }}>
            {traitIcons[trait]} {trait}
          </span>
        ))}
      </div>
    </div>
  );
} 